import { render, staticRenderFns } from "./AlliedPartyAgenda.vue?vue&type=template&id=4ac8d675"
import script from "./AlliedPartyAgenda.vue?vue&type=script&lang=ts"
export * from "./AlliedPartyAgenda.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports